import { render, staticRenderFns } from "./resumo-dirigentes-table.vue?vue&type=template&id=085c2777"
import script from "./resumo-dirigentes-table.vue?vue&type=script&lang=js"
export * from "./resumo-dirigentes-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports